import APIService from "./APIService";

export default {
  async getDadosByArea(competencia_de, competencia_ate, areas) {
    const res = await APIService.apiCall().get(
      "dashboard-servicos-area/get-dados-by-area",
      {
        params: {
          competencia_de,
          competencia_ate,
          areas,
        },
      }
    );
    return res.data;
  },

  async getDadosAreaByCompetencia(competencia_de, competencia_ate, areas) {
    const res = await APIService.apiCall().get(
      "dashboard-servicos-area/get-dados-area-by-competencia",
      {
        params: {
          competencia_de,
          competencia_ate,
          areas,
        },
      }
    );
    return res.data;
  },

  async getDadosByGerencia(competencia_de, competencia_ate, gerencias) {
    const res = await APIService.apiCall().get(
      "dashboard-servicos-area/get-dados-by-gerencia",
      {
        params: {
          competencia_de,
          competencia_ate,
          gerencias,
        },
      }
    );
    return res.data;
  },

  async getDadosGerenciaByCompetencia(
    competencia_de,
    competencia_ate,
    gerencias
  ) {
    const res = await APIService.apiCall().get(
      "dashboard-servicos-area/get-dados-gerencia-by-competencia",
      {
        params: {
          competencia_de,
          competencia_ate,
          gerencias,
        },
      }
    );
    return res.data;
  },
};
